/* cSpell:disable */
import * as Yup from 'yup';
import { TranslationProps } from 'ff-shared-components-core';

export const serviceChargeSchema = (
	props: TranslationProps
): Yup.ObjectSchema<Yup.Shape<
	object,
	{
		ibanNumber: string;
		ibanProofFile: object;
	}
>> => {
	const { t } = props;
	return Yup.object().shape({
		ibanNumber: Yup.string()
			.min(5, t('errors.form.iban-min-length'))
			.max(34, t('errors.form.iban-max-length'))
			.required(t('errors.form.ibanNumber')),
		ibanProofFile: Yup.object()
			.nullable()
			.shape({
				name: Yup.string().required(t('errors.form.file-validation.name')),
				// type: Yup.string().required(t('errors.form.file-validation.type')),
				// base64File: Yup.string().required(t('errors.form.file-validation.base64File')),
			})
			.required(t('errors.form.file-validation.required')),
	});
};
